module.exports = __webpack_public_path__ + "img/BradfordWhite_NoCaption_Logo.5a64399e.png";